module.exports = __webpack_public_path__ + "img/login-1.6cdfc303.jpg";